import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Financing from "@/pages/Financing";

export const Route = createFileRoute("/_public/financing")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Fence Financing | Flexible Payments via Affirm", "Finance your fence installation over 12\u201360 months with Affirm. Transparent, fixed monthly payments. Pre-qualify in seconds \u2014 no impact to credit.", "/financing", false),
  component: Financing,
});
